<template>
  <div class="container" style="margin-top: 3cm">
    <h2 class="text-center">关于组织申报2026年度四川省企业管理现代化创新成果、优秀论（著）文的通知</h2>
    <p class="box_p text-center">
      <span>发布时间： </span>
      <span id="date" style="display: inline-block; margin-left: -10px">
         2026-03-24 16:36:33
        </span>
      <span style="margin-left: 16px">编辑： </span>
      <span id="author" style="display: inline-block; margin-left: -10px">
         管理员
        </span>
    </p>
    <div style="letter-spacing:2px">
      各市州及行业企联（企协）、各成果创造单位、有关企业：<br>
           为深入学习贯彻习近平新时代中国特色社会主义思想，贯彻实施国家“十五五”规划纲要，扎实推进企业管理创新，推动企业高质量发展，按照中共中央 国务院《关于营造企业家健康成长环境弘扬优秀企业家精神更好发挥企业家作用的意见》和《关于加快建设世界一流企业的指导意见》等文件部署，中共中央办公厅、国务院办公厅2018年印发的持续推动管理创新成果审定和推广的文件要求，以及国家工信部、国资委和中企联对管理创新工作的部署，我会决定开展2026年度四川省企业管理现代化创新成果、优秀论（著）文的申报、推荐与审定工作。具体要求与程序请下载红头文件查看。<br><br>
      四川省企业联合会 四川省企业家协会
      四川省企业管理现代化创新成果审定委员会<br>
      2026年03月24日<br><br>
      <dl>
        <dt>附件下载：</dt>
        <dd><a style="color: #1c84c6" href="static/file/关于组织申报2026年度四川省企业管理现代化创新成果、优秀论（著）文的通知.pdf" download>关于组织申报2026年度四川省企业管理现代化创新成果、优秀论（著）文的通知</a></dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/NoticeDetails3.vue